import React from 'react';
import cc from 'classcat';

interface ITable {
    children: React.ReactNode;
    className?: string;
}

interface ITableHeadCell {
    children?: React.ReactNode;
    className?: string;
    smallPadding?: boolean;
}

interface ITableCell extends ITable {
    noBottomBorder?: boolean;
    colSpan?: number;
    onClick?: () => void;
}

interface ITableRow extends ITable {
    onClick?: () => void;
}

export const Table = ({ children, className }: ITable) => {
    return (
        <div className={cc(['table-wrapper', className])}>
            <table className="table">
                <tbody>{children}</tbody>
            </table>
        </div>
    );
};

export const TableRow = ({ children, className, onClick }: ITableRow) => {
    return (
        <tr className={cc(['table__row', className])} onClick={onClick}>
            {children}
        </tr>
    );
};

export const TableHeadCell = ({ children, className, smallPadding }: ITableHeadCell) => {
    return <th className={cc(['table__h-cell', { 'table__h-cell--small-padding': smallPadding }, 'paragraph-4', className])}>{children}</th>;
};

export const TableCell = ({ children, noBottomBorder, className, colSpan, onClick }: ITableCell) => {
    return (
        <td
            onClick={onClick}
            className={cc(['table__cell', 'paragraph-3', { 'table__cell--no-bottom-border': noBottomBorder }, className])}
            colSpan={colSpan}
        >
            {children}
        </td>
    );
};
